import styled from 'styled-components';

export const ImageContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['aspectRatio'].includes(prop),
})<{
  aspectRatio: string | number;
}>`
  position: relative;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  overflow: hidden;
  background-color: rgb(227, 227, 222);

  img {
    transition: transform 0.5s;
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .play-icon {
    pointer-events: none;
  }

  &.img-container-with-slider-toggle {
    cursor: zoom-in;

    img {
      pointer-events: none !important;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      pointer-events: none;
      -webkit-user-drag: none;
    }
  }
`;
